import type { Settings } from './types';

export const useSettings = (): Settings & {
	orderCheckinLocation?: boolean;
	useQuickCheckout?: boolean;
	useReservationsClose?: boolean;
} => {
	const {
		autoGenerateCodes,
		timeFormat24,
		weekStart,
		forceCheckListCheckin,
		useHours,
		useKits,
		useLockedKits,
		currency,
		useOrders,
		useReservations,
		useSpotcheck,
		custodyCanChangeLocation,
		useReporting,
		customQrCodePrefix,
		customQrCodePrefixes,
		useEquipmentPicking,
		usePastOrders,
		useBlockEditOfOpenOrders,
		usePastReservations,
		useBlockEditOfOpenReservations,
		orderCheckinLocation,
		useQuickCheckout,
		useReservationsClose,
		useTickets,
	} = window?.global?.central?.profile() || {};

	return {
		autoGenerateCodes,
		timeFormat24,
		weekStart,
		forceCheckListCheckin,
		useHours,
		useKits,
		useLockedKits,
		currency,
		useOrders,
		useReservations,
		useSpotcheck,
		custodyCanChangeLocation,
		useReporting,
		customQrCodePrefix,
		customQrCodePrefixes,
		useEquipmentPicking,
		usePastOrders,
		useBlockEditOfOpenOrders,
		usePastReservations,
		useBlockEditOfOpenReservations,
		orderCheckinLocation,
		useQuickCheckout,
		useReservationsClose,
		useTickets,
	};
};
